<template lang="pug">
div.mt-2
  v-row
    v-col(cols="4")
      //- y-select(v-model="form.provider" :items="providers" item-text="name" item-value="id" :placeholder="$t('select_doctor')" :rules="rules.not_empty_select" :loading="isFetchingProvider" no-data-text="No provider available" @change="changeProvider(form.provider)")
      v-autocomplete.round-xl.icon-height(v-model="form.provider" :items="providers" item-text="name" item-value="id" :placeholder="$t('select_doctor')" :rules="rules.not_empty_select" :loading="isFetchingProvider" no-data-text="No provider available" outlined dense height="48" append-icon="$yzi-chevron-down" hide-details="auto" @change="changeProvider(form.provider)")
    v-col(cols="4")
      //- y-select(v-model="form.service" :items="services" item-text="name" item-value="id" :placeholder="$t('select_service_type')" :rules="rules.not_empty_select" :loading="isFetchingService" no-data-text="No service available" @change="changeService(form.service)")
      v-autocomplete.round-xl.icon-height(v-model="form.service" :items="services" item-text="name" item-value="id" :placeholder="$t('select_service_type')" :rules="rules.not_empty_select" :loading="isFetchingService" no-data-text="No service available" outlined dense height="48" append-icon="$yzi-chevron-down" hide-details="auto" @change="changeService(form.service)")
    v-col(cols="4")
      div
        slot(name="button")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      required: true,
      type: Array,
      default: (() => [])
    }
  },
  data () {
    return {
      isFetchingService: false,
      isFetchingProvider: false,
      form: {},
      providers: [],
      services: [],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
  },
  watch: {
    form: {
      deep: true,
      handler (val) {
        let valueIdx = this.value.findIndex(f => JSON.stringify(f) === JSON.stringify(val))
        let newVal = this.value
        if (valueIdx !== -1) {
          newVal.splice(valueIdx, 1, val)
        } else {
          newVal.push(val)
        }
        this.$emit('input', newVal)
      }
    }
  },
  mounted () {
    this.fetchProviders()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProviders () {
      this.isFetchingProvider = true
      let params = {
        page_size: -1,
        status: 'active',
        fields: 'id,name,profile_image'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/providers`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.providers = resp.data.results
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingProvider = false
        })
    },
    fetchServices (provider) {
      this.getProviderDetails(provider)
      !this.form.service || this.$set(this.form, 'service', null)
      this.isFetchingService = true
      let params = {
        page_size: -1,
        booking_enabled: true,
        fields: 'id,name',
        providers: provider
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/services`,  { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.services = resp.data.results
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingService = false
        })
    },
    fetchServicesDetails (service) {
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/services/${service}`)
        .then(resp => {
          this.$set(this.form, 'serviceDetails', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    getProviderDetails (id) {
      let details = this.providers.find(f => f.id === id)
      if (details) {
        this.$set(this.form, 'providerDetails', details)
      }
    },
    changeProvider (provider) {
      if (!provider) {
        this.services = []
        return 
      }
      this.$emit('change')
      this.fetchServices(provider)
    },
    changeService (service) {
      if (!service) {
        return 
      }
      this.fetchServicesDetails(service)
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .icon-height .v-input__control .v-input__append-inner .v-input__icon {
    height: 32px;
  }
}
</style>